"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductTypes = void 0;
var ProductTypes;
(function (ProductTypes) {
    ProductTypes["Fabric"] = "Fabric";
    ProductTypes["Zippers"] = "Zippers";
    ProductTypes["Buttons"] = "Buttons";
    ProductTypes["Elastic"] = "Elastic";
    //Lace = 'Lace',
    ProductTypes["Sewing Patterns"] = "Sewing Patterns";
    ProductTypes["Thread"] = "Thread";
    ProductTypes["Trim"] = "Trim";
    ProductTypes["Ribbing"] = "Ribbing";
    ProductTypes["Bias Tape"] = "Bias Tape";
    ProductTypes["Other Supply"] = "Other Supply";
})(ProductTypes = exports.ProductTypes || (exports.ProductTypes = {}));
//# sourceMappingURL=product.js.map